import { createAsyncThunk } from "@reduxjs/toolkit";
import { companySliceName } from "..";
import server from "../../../../config/server";

export const insertTeacherAction = createAsyncThunk(`${companySliceName}/insertTeacher`, async (data, thunkAPI) => {
  try {
    const response = await server.post("/app/teacher", data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || { message: "ERROR!" });
  }
});

export const updateTeacherAction = createAsyncThunk(`${companySliceName}/updateTeacher`, async (data, thunkAPI) => {
  try {
    const response = await server.put("/app/teacher", data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || { message: "ERROR!" });
  }
});

export const getTeachersAction = createAsyncThunk(`${companySliceName}/getTeachers`, async (_, thunkAPI) => {
  try {
    const response = await server.get("/app/teacher/views", {}, {});
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteTeacherAction = createAsyncThunk(`${companySliceName}/deleteTeacher`, async (uuid, thunkAPI) => {
  try {
    const response = await server.delete(`/app/teacher?uuid=${uuid}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || { message: "ERROR!" });
  }
});
